var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.218,
    height: 23.2,
    viewBox: "0 0 24.218 23.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_200",
    "data-name": "Union 200",
    d: "M1097.185-2420.8a3.184,3.184,0,0,1-3.17-3.182v-11.461c0-.088,0-.178-.008-.266a2.505,2.505,0,0,1,.057-.808,1.439,1.439,0,0,1,.059-.167,2.624,2.624,0,0,1,.7-.911l4.132-3.715q.94-.848,1.882-1.694c.094-.084.186-.169.279-.256.144-.134.294-.273.447-.4a1.545,1.545,0,0,1,1.068-.336c.1,0,.194,0,.289.007s.19.007.284.007h5.82a3.184,3.184,0,0,1,3.17,3.181v4.247l1.415-1.419a2.245,2.245,0,0,1,1.6-.664,2.248,2.248,0,0,1,1.6.663l.749.751a2.283,2.283,0,0,1,0,3.211l-5.361,5.384v4.651a3.184,3.184,0,0,1-3.169,3.182Zm-1.372-3.182a1.377,1.377,0,0,0,1.372,1.377h11.842a1.378,1.378,0,0,0,1.371-1.378v-2.845l-1.523,1.53a.894.894,0,0,1-.415.237l-3.588.911a.892.892,0,0,1-.442,0,.9.9,0,0,1-.649-1.1l.911-3.6a.9.9,0,0,1,.235-.415l5.47-5.492v-6.051a1.379,1.379,0,0,0-1.371-1.377h-5.854v3.437a3.185,3.185,0,0,1-3.17,3.182h-4.191Zm10.562-4.178-.478,1.887,1.882-.479,6.92-6.948-1.4-1.409Zm8.507-8.541-.315.316,1.4,1.409.316-.316a.469.469,0,0,0,0-.659l-.759-.761a.461.461,0,0,0-.316-.125A.46.46,0,0,0,1114.882-2436.7Zm-17.617-.666H1100a1.378,1.378,0,0,0,1.371-1.377v-2.319Z",
    transform: "translate(-1094 2444)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBuilder);
export default __webpack_public_path__ + "static/media/formBuilder.4f6a17791d5df8df6cd0dc37e641edda.svg";
export { ForwardRef as ReactComponent };